import { useState } from 'react';
import { usersApi } from '../api';
import { useData, submitForm, useSubmit } from '../hooks/useData';
import { Spinner, Modal, PageHeader, Field, Empty, EditBtn } from '../components/common';

const EMPTY = { username: '', password: '', full_name: '', role: 'user' };

export default function UsersPage() {
  const { data, loading, reload } = useData(usersApi.list);
  const [modal, setModal]         = useState(null);
  const [doSubmit, saving] = useSubmit();
  const [form, setForm]           = useState(EMPTY);
  const set = e => setForm(f => ({ ...f, [e.target.name]: e.target.value }));

  return (
    <div>
      <PageHeader title="Users" subtitle="Manage system access and roles"
        action={<button className="btn btn-primary btn-sm" onClick={() => { setForm(EMPTY); setModal('add'); }}>+ Add User</button>} />
      <div className="card">
        {loading ? <Spinner /> : (
          <div className="table-wrap">
            {data.length === 0 ? <Empty /> : (
              <table className="responsive-table">
                <thead><tr><th>Username</th><th>Full Name</th><th>Role</th><th>Status</th><th>Created</th><th>Actions</th></tr></thead>
                <tbody>{data.map(r => (
                  <tr key={r.id}>
                    <td data-label="Username" className="td-primary font-mono">{r.username}</td>
                    <td data-label="Full Name">{r.full_name}</td>
                    <td data-label="Role"><span className={`badge badge-${r.role}`}>{r.role}</span></td>
                    <td data-label="Status"><span className={`badge ${r.active_yes_no ? 'badge-active' : 'badge-inactive'}`}>{r.active_yes_no ? 'Active' : 'Inactive'}</span></td>
                    <td data-label="Created" className="text-muted" style={{ fontSize: '.8rem' }}>{r.created_at?.slice(0,10)}</td>
                    <td data-label="Actions"><div className="action-cell"><EditBtn onClick={() => { setForm({ ...r, password: '' }); setModal('edit'); }} /></div></td>
                  </tr>
                ))}</tbody>
              </table>
            )}
          </div>
        )}
      </div>

      {modal && (
        <Modal title={modal === 'add' ? 'Add User' : 'Edit User'} onClose={() => setModal(null)}
          footer={<>
            <button className="btn btn-secondary" onClick={() => setModal(null)}>Cancel</button>
            <button className="btn btn-primary" onClick={() => {
              if (modal === 'add') doSubmit(() => usersApi.create(form), 'User created', reload, () => setModal(null));
              else doSubmit(() => usersApi.update(form.id, form), 'User updated', reload, () => setModal(null));
            }}>Save User</button>
          </>}>
          <div className="form-row form-row-2">
            <Field label="Username" required><input type="text" name="username" value={form.username} onChange={set} disabled={modal === 'edit'} autoFocus /></Field>
            <Field label="Full Name" required><input type="text" name="full_name" value={form.full_name} onChange={set} /></Field>
          </div>
          <div className="form-row form-row-2">
            <Field label={modal === 'edit' ? 'New Password (leave blank to keep)' : 'Password'} required={modal === 'add'}>
              <input type="password" name="password" value={form.password} onChange={set} autoComplete="new-password" />
            </Field>
            <Field label="Role">
              <select name="role" value={form.role} onChange={set}>
                <option value="user">User</option>
                <option value="admin">Admin</option>
              </select>
            </Field>
          </div>
          {modal === 'edit' && (
            <Field label="Status">
              <select name="active_yes_no" value={form.active_yes_no} onChange={e => setForm(f => ({ ...f, active_yes_no: Number(e.target.value) }))}>
                <option value={1}>Active</option><option value={0}>Inactive</option>
              </select>
            </Field>
          )}
        </Modal>
      )}
    </div>
  );
}
